module.exports = __webpack_public_path__ + "f30e54f2dd7980f38bc50f246c90b580.MP3";